import state from './moduleDialerState';
import mutations from './moduleDialerMutations';
import actions from './moduleDialerActions';
// import getters from './moduleDialerGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  // getters,
};



// WEBPACK FOOTER //
// ./src/store/dialer/moduleDialer.js